// 共享的 i18n 常量和类型定义
// 此文件不包含任何客户端或服务器端特定的代码，可以在任何地方安全导入

// 支持的语言列表
export const SUPPORTED_LANGUAGES = {
	zh: '简体中文',
	en: 'English',
} as const;

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES;

// 默认语言
export const DEFAULT_LANGUAGE: SupportedLanguage = 'zh';

// 语言包命名空间
export const NAMESPACES = {
	COMMON: 'common',
	AUTH: 'auth',
	PAPERS: 'papers',
	WORKFLOW: 'workflow',
	UI: 'ui',
	DASHBOARD: 'dashboard',
	SIDEBAR: 'sidebar',
	PRICING: 'pricing',
	DESKTOP: 'desktop',
} as const;
